<template>
    <div>
        <template v-for="( key, index ) in headers">
            <span
                class="table__body__row__text position--relative"
                :class="`table__${model}__col__${index}`"
                :key="index"
            >
                {{ row[key] || '---' }}
            </span>
        </template>
        <div class="table__request__col__5 display--flex row__request__actions">
            <button-with-icon
                :icon="{
                    component: () => import( /* webpackChunkName: 'IconListen' */ '@/components/bundles/layout/images/icons/IconListen' ),
                    ...( call.confirmed && {
                        class: 'row__request__actions__listen--active'
                    }),
                    ...( listen.loading && {
                        class: 'row__request__actions__default--loading'
                    })
                }"
                :class="[
                    'table__body__row__text__button'
                ]"
                :aria-label="$t('accessibility.toListen')"
                :action="{
                    execute: true,
                    function: toggleListenCall,
                    param: { extension: row.extension }
                }"
            />
            <button-with-icon
                v-if="row.id"
                :icon="{
                    component: () => import( /* webpackChunkName: 'IconTransferCall' */ '@/components/bundles/layout/images/icons/IconTransferCall' ),
                    ...( intercept.loading && {
                        class: 'row__request__actions__default--loading'
                    })
                }"
                :class="[
                    'table__body__row__text__button'
                ]"
                :aria-label="$t('accessibility.transferCall')"
                :action="{
                    execute: true,
                    function: interceptCall,
                    param: { id: row.id, extension: row.extension }
                }"
            />
        </div>
    </div>
</template>

<script>
// packages
import {
    onUnmounted,
    reactive,
    toRefs,
    watch
} from '@vue/composition-api';

// jssip
import { call, hangUp } from '@/plugins/jssip';

export default {
    components: {
        ButtonWithIcon: () => import( /* webpackChunkName: 'ButtonWithIcon' */ '@/components/bundles/buttons/BaseButtonWithIcon' )
    },
    props: {
        headers: Array,
        row: Object,
        model: String,
        action: Function
    },
    setup ( props, { parent }) {
        const state = reactive({
            listen: {
                loading: false,
                active: false
            },
            intercept: {
                loading: false,
                active: false
            },
            call: { number: null, confirmed: false, end: false }
        });

        /**
         * Iniciação da escuta da chamada.
         * Conforme se a escuta esta activa, é
         * procedido a acção correspondente.
         *
         * @param {String} extension
         * @since 1.1.0
         * @category Função
         * @autor Tiago Martinho
         *
        */
        const toggleListenCall = ({ extension }) => {
            state.listen.loading = true;
            state.call.number = `9999${extension}`; // 9999 - extensão para escutar

            if ( !state.listen.active )
                call({ settings: state.call });
            else {
                hangUp();
                state.loading = false;
                state.call.confirmed = false;
            }

            state.listen.active = !state.listen.active;
        };

        /**
         * Iniciação da intercepção da chamada.
         *
         * @param {String} extension
         * @since 1.1.0
         * @category Função
         * @autor Tiago Martinho
         *
        */
        const interceptCall = async ({ id, extension }) => {
            if ( state.intercept.active )
                return;

            state.intercept.loading = true;

            parent.$emit( 'intercept-call', { id, extension });

            state.intercept.active = !state.intercept.active;
        };

        /**
         * Listener para detectar quando a chamada
         * é confirmada, de forma a dar o toggle
         * no loading
         *
         * @since 1.1.0
         * @category watch
         * @autor Tiago Martinho
         *
        */
        watch( () => state.call.confirmed,
            isConfirmed => {
                if ( isConfirmed )
                    state.listen.loading = false;
            });

        /**
         * Listener para detectar quando a chamada
         * termina, de forma a dar o toggle
         * na chamada confirmada.
         *
         * @since 1.1.0
         * @category watch
         * @autor Tiago Martinho
         *
        */
        watch( () => state.call.end,
            () => {
                state.call.confirmed = false;
                state.listen.loading = false;
                state.listen.active = false;
            });

        /**
         * Quando o componente é destruído, e se
         * houver uma chamada activa, é necessário
         * desligar.
         *
         * @since 1.1.0
         * @category event
         * @autor Tiago Martinho
         *
        */
        onUnmounted( () => {
            if ( state.call.confirmed )
                hangUp();
        });

        return { ...toRefs( state ), toggleListenCall, interceptCall };
    }
};
</script>

<style lang="scss">
    .row {
        &__request {
            &__actions {
                justify-content: flex-end;
                gap: 25px;
                &__default {
                    &--loading {
                        .circle {
                            fill: url( #loading );
                        }
                        .path {
                            stroke: url( #loading );
                        }
                    }
                }
                &__listen {
                    &--active {
                        .circle {
                            fill: $color-red;
                        }
                        .path {
                            stroke: $color-red;
                        }
                    }
                }
            }
        }
    }
</style>